// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7b0I9","img":"styles_img__6z00+","single":"styles_single__QItQc","skeleton":"styles_skeleton__hoBZM"};